import './styles/main.css';
import { initContactDialog } from './contact-dialog';
import { initContentSwitches } from './content-switch';
import { initFeaturesToggle } from './features-toggle';
import { initNewsletter } from './newsletter';
import { initScrollReveal } from './scroll-reveal';
import { initTilt } from './tilt';

initContactDialog();
initContentSwitches();
initFeaturesToggle();
initNewsletter();
initScrollReveal(); // features grid: rows cascade as they enter
initScrollReveal('.trusted-by__logos .trusted-by__item', 'order');
initScrollReveal('.intro__use-cases .use-case', 'order');
initScrollReveal('.contact__cards .contact-card', 'order');
initTilt('.features__grid .feature');
initTilt('.intro__use-cases .use-case');
initTilt('.contact__cards .contact-card');
